import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom'; // ← Cambiato
import API_BASE_URL from '../config';
import axios from 'axios';
import '../styles/CancelBooking.css';

const CancelBooking = () => {
    const { code: urlCode } = useParams();
    const history = useHistory(); // ← Invece di useNavigate
    const [bookingCode, setBookingCode] = useState(urlCode || '');
    const [booking, setBooking] = useState(null);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (urlCode) {
            handleSearch();
        }
    }, [urlCode]);

    const handleSearch = async () => {
        if (!bookingCode || bookingCode.trim() === '') {
            setError('Inserisci un codice prenotazione');
            return;
        }

        if (!bookingCode.startsWith('PREN-')) {
            setError('Codice non valido. Deve iniziare con PREN-');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await axios.get(
                `${API_BASE_URL}/api/bookings/code/${bookingCode}`
            );

            if (response.data.success) {
                setBooking(response.data.data);
            } else {
                setError('Prenotazione non trovata');
            }
        } catch (err) {
            setError(err.response?.data?.error || 'Errore durante la ricerca');
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = async () => {
        if (!window.confirm('Sei sicuro di voler cancellare questa prenotazione?')) {
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await axios.delete(
                `${API_BASE_URL}/api/bookings/cancel/${bookingCode}`
            );

            if (response.data.success) {
                setSuccess(true);
                setBooking(null);
            } else {
                setError('Errore durante la cancellazione');
            }
        } catch (err) {
            setError(err.response?.data?.error || 'Errore durante la cancellazione');
        } finally {
            setLoading(false);
        }
    };

    const handleNewBooking = () => {
        history.push('/prenota'); // ← Invece di navigate('/prenota')
    };

    if (success) {
        return (
            <div className="cancel-booking-page">
                <div className="cancel-booking-container">
                    <div className="success-message">
                        <div className="success-icon">✓</div>
                        <h2>Prenotazione Cancellata</h2>
                        <p>La tua prenotazione è stata cancellata con successo.</p>
                        <p>Riceverai un'email di conferma a breve.</p>
                        <button 
                            className="btn-primary"
                            onClick={handleNewBooking}
                        >
                            Prenota di nuovo
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="cancel-booking-page">
            <div className="cancel-booking-container">
                <h1>Cancella Prenotazione</h1>
                <p className="subtitle">
                    Inserisci il codice di prenotazione che hai ricevuto via email
                </p>

                <div className="search-section">
                    <input
                        type="text"
                        placeholder="PREN-XXXXXX"
                        value={bookingCode}
                        onChange={(e) => setBookingCode(e.target.value.toUpperCase())}
                        maxLength={12}
                    />
                    <button 
                        onClick={handleSearch}
                        disabled={loading}
                        className="btn-search"
                    >
                        {loading ? 'Ricerca...' : 'Cerca'}
                    </button>
                </div>

                {error && (
                    <div className="error-message">
                        ⚠️ {error}
                    </div>
                )}

                {booking && (
                    <div className="booking-details">
                        <h3>Dettagli Prenotazione</h3>
                        <div className="detail-row">
                            <span className="label">Codice:</span>
                            <span className="value">{booking.booking_code}</span>
                        </div>
                        <div className="detail-row">
                            <span className="label">Nome:</span>
                            <span className="value">{booking.customer_name}</span>
                        </div>
                        <div className="detail-row">
                            <span className="label">Email:</span>
                            <span className="value">{booking.customer_email}</span>
                        </div>
                        <div className="detail-row">
                            <span className="label">Telefono:</span>
                            <span className="value">{booking.customer_phone}</span>
                        </div>
                        <div className="detail-row">
                            <span className="label">Data:</span>
                            <span className="value">
                                {new Date(booking.booking_date).toLocaleDateString('it-IT', {
                                    weekday: 'long',
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                })}
                            </span>
                        </div>
                        <div className="detail-row">
                            <span className="label">Ora:</span>
                            <span className="value">{booking.booking_time.substring(0, 5)}</span>
                        </div>
                        <div className="detail-row">
                            <span className="label">Ospiti:</span>
                            <span className="value">{booking.number_of_guests}</span>
                        </div>
                        {booking.special_requests && (
                            <div className="detail-row">
                                <span className="label">Note:</span>
                                <span className="value">{booking.special_requests}</span>
                            </div>
                        )}

                        <button 
                            onClick={handleCancel}
                            disabled={loading}
                            className="btn-cancel"
                        >
                            {loading ? 'Cancellazione...' : 'Cancella Prenotazione'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CancelBooking;